import React from 'react';

import PropTypes from 'prop-types';

import { getValidChildrenCount } from '@adsk/alloy-react-helpers';
import theme, {
  stylePropType,
  StylableComponent,
} from '@adsk/alloy-react-theme';

import { useTranslation } from '../../i18n';

export type NoAutocompleteResultsProps =
  StylableComponent<HTMLParagraphElement>;

const NoAutocompleteResults = ({
  className,
  style,
  children,
  ...props
}: NoAutocompleteResultsProps) => {
  const { t } = useTranslation();
  const text = getValidChildrenCount(children) > 0 ? children : t('NO_RESULTS');

  return (
    <p
      data-testid="Dropdown__noResults"
      className={className}
      css={[
        {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: 0,
          height: 32,
          color: theme.tokens.colors.text.secondary.value,
        },
        theme.typography.bodySmall,
        style,
      ]}
      {...props}
    >
      {text}
    </p>
  );
};

NoAutocompleteResults.displayName = 'NoAutocompleteResults';

NoAutocompleteResults.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Override for no results content */
  children: PropTypes.any,
};

export default NoAutocompleteResults;
